export const getProductImage = (imageName) => {
  const BASE_URL = "https://marchedeluxe.ch/images/";
  const clean = imageName?.replace("images/", "").trim();

  return clean ? `${BASE_URL}${clean}` : `${BASE_URL}placeholder.png`;
};
